// What is the logged in user's id?
export const userId = state => state.userId;

// Is the user logged in?
export const userLoggedIn = state => userId(state) !== "0";

// What are the favourites lists of the user?
export const lists = state => state.lists;

// Does the artwork have a remove icon?
export const hasRemove = state => artId =>
  Array.isArray(state.lists) &&
  state.lists.filter(
    list => list.artworks && list.artworks.includes(parseInt(artId, 10))
  ).length > 0;

// Is the "copied" content visible?
export const copiedVisible = state => artId =>
  state.artwork &&
  state.artwork[artId] &&
  state.artwork[artId].boxContent === "copied";

// Is the "add" content visible=
export const addVisible = state => artId =>
  state.artwork &&
  state.artwork[artId] &&
  state.artwork[artId].boxContent === "add";

// Is the "remove" content visible?
export const removeVisible = state => artId =>
  state.artwork &&
  state.artwork[artId] &&
  state.artwork[artId].boxContent === "remove";

// Is the "action box" visible?
export const boxVisible = state => artId =>
  state.artwork && state.artwork[artId] && state.artwork[artId].boxVisible;

// Is the input dialog for a new list name visible?
export const inputVisible = state => state.inputVisible;

// Is list creation in progress?
export const creatingList = state => state.creatingList;

// Is the input in an errored state?
export const inputError = state => state.inputError;

// Is adding to list in progress?
export const addingToList = state => listId =>
  state.lists && state.lists.find(list => list.id === listId).addingToList;

// Is removing from list in progress?
export const removingFromList = state => listId =>
  state.lists && state.lists.find(list => list.id === listId).removingFromList;
